var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDudeRedSpeaking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 153,
    viewBox: "0 0 200 153",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0503C",
    d: "M47.225 29L139 120.332V153H0V76.883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M30.299 109l18.873 18.747H70V138H44.935v-.04l-.039.04L23 116.25z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31 68h42.222v18H31zM83.778 68H126v18H83.778z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dude-eyes",
    fill: "#FFF",
    d: "M111.926 71.6h10.556v10.8h-10.556zM59.148 71.6h10.556v10.8H59.148z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "dude-chat-bubble",
    fill: "#E2E6E9",
    d: "M120 58.125l21.875-21.875V0H200v58.125z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDudeRedSpeaking);
export default __webpack_public_path__ + "static/media/dude-red-speaking.b69b5841.svg";
export { ForwardRef as ReactComponent };